import React, { useEffect, useState } from 'react'
import { postCambiodeEstadooUSer,  postSelectCambiarEstadoPaciente,  postUpdateHCCOM5yHCCOM51Realizada } from '../../../services/PaginaRuta'
import ModalValidarEstadoRealizada from './ModalValidarEstadoRealizada'
import { HoraActual, fechaActual } from "../../../hooks/UseDate";

const CambioDeEstadoRealizada = ({setmodalOnCambioEstadoRealizada,user,passChildCambioDeEstado}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnValidarDescripcionQuirurgica, setmodalOnValidarDescripcionQuirurgica]=useState(false)  
  const handleCancelarClick=()=>{
        setmodalOnCambioEstadoRealizada(false)
    }
    const handleOnclickConfirmarRealizada=()=>{
      let fecha = new Date();
        let mes = `${fecha.getMonth() + 1}`    
        if(mes.length === 1){
          mes = "0" + mes
        }
        let dia = `${fecha.getDate()}`
        if(dia.length === 1){
          dia = "0" + dia
        }
        
        const body = {
          Id_cirugia: user.ProCirCod,
          cedula_paciente: user.MPCedu,
          nombre_cirujano: user.MPNOMC,
          nombre_paciente: user.MPNOMC,
          estado_paciente: 'recuperacion',
          fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
          hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
        };
        //postCambiodeEstadooUSer(updateEstadoRealizada)
        postSelectCambiarEstadoPaciente(body)
        
        
        const updateHCCOM51yHCCOM5 =  {
          "HISCKEY": user.MPCedu,
          "HISTipDoc": user.MPTDoc,
          "HCPrcCns": "1",
          "HCPrStGr":"A",
          "HCPrcEst":"A",
          "HCPrcHrRe": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
          "HCFcHrAp": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
          "CodEmpCod":usuarioInfo.Empresa,
          "CodMcdpto":usuarioInfo.Sede,
          "HCProCir":user.ProCirCod,
          "CodCir":user.ProCirCod,
          "HCPrcCod":''
      }
      console.log(updateHCCOM51yHCCOM5,'antes updateHCCOM51yHCCOM5')
      postUpdateHCCOM5yHCCOM51Realizada(updateHCCOM51yHCCOM5).then(res=>{
        console.log(res.data,'HCCOM5 Y HCCOM51')
      })

        passChildCambioDeEstado({
            estadoPaciente:'15',
            disabledPendiente:true,
            disabledReservado:true,
            disabledConfirmado:true,
            disabledIngresoSala:true,
            disabledPreparado:true,
            disabledCirugia:true,
            disabledRecuperacion:true,
            disabledSalida:false,
            disabledCancelar:true,
            disabledRealizada:true,
            disabledFacturada:true
        })
        setmodalOnCambioEstadoRealizada(false)
      /////
        // const medico={
        //   ProEmpCod:'1',
        //   ProMCDpto:'001',
        //   ProCirCod:user.ProCirCod
        // }
        // postSelectMedCodDX(medico).then((resp)=>{
        //   const medicoDQ = resp.data[0].MedCod
        //   const validarDescripcionQuirurgica={
        //     CodEmpCod:'1',
        //     CodMcdpto:'001',
        //     CodMed: medicoDQ,
        //     CodCir:user.ProCirCod,
        //     EstCir:'4'
        //   }
        //   console.log( validarDescripcionQuirurgica,'codmed')
        //   postQXValidarRealizada(validarDescripcionQuirurgica).then((res)=>{
        //     //const procir = 
        //     console.log(res.data,'validarrrr')
        //     if(res.data.length !== 0){
        //       //console.log(res.data,'entro')
        //       const updateEstadoRealizada={
        //         ProCirCod: user.ProCirCod,
        //         ProMCDpto: "001      ",
        //         ProEmpCod: "1 ",
        //         ProEsta: '4',
        //         PUsrConf: "CUE9F3Q8  ",
        //         }
        //         postCambiodeEstadooUSer(updateEstadoRealizada)
        //         passChildCambioDeEstado({
        //             estadoPaciente:'4',
        //             disabledPendiente:true,
        //             disabledReservado:true,
        //             disabledConfirmado:true,
        //             disabledIngresoSala:true,
        //             disabledPreparado:true,
        //             disabledCirugia:true,
        //             disabledRecuperacion:true,
        //             disabledSalida:true,
        //             disabledCancelar:true,
        //             disabledRealizada:true,
        //             disabledFacturada:true
        //         })
        //         setmodalOnCambioEstadoRealizada(false)
        //     }else{
        //       setmodalOnValidarDescripcionQuirurgica(true)
        //     }
        //   })
        // })
        
        
        
    }
    useEffect(()=>{
      const updateHCCOM51yHCCOM5 =  {
        "HISCKEY": user.MPCedu,
        "HISTipDoc": user.MPTDoc,
        "HCPrcCns": "1",
        "HCPrStGr":"A",
        "HCPrcEst":"A",
        "HCPrcHrRe": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
        "HCFcHrAp": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
        "CodEmpCod": usuarioInfo.Empresa,
        "CodMcdpto":usuarioInfo.Sede,
        "HCProCir":user.ProCirCod,
        "CodCir":user.ProCirCod
    }
      console.log(updateHCCOM51yHCCOM5,'userr')
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Mensaje 
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Esta seguro de cambiar a "Recuperación"?
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <button
              type="button"
              onClick={handleOnclickConfirmarRealizada}
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Si
            </button>
          </div>
        </div>
      </div>
      {modalOnValidarDescripcionQuirurgica? <ModalValidarEstadoRealizada setmodalOnValidarDescripcionQuirurgica={setmodalOnValidarDescripcionQuirurgica} user={user}/>:null}
    </div>
  )
}

export default CambioDeEstadoRealizada